import { Sorter as Srt } from 'projects/exi-ui/src/lib/utils/sorter.class';
import { Col } from '../../cols/col.class';
import { AbstractSorter, DefaultSort } from '../abstract/sorter.class';
import { LocalTable } from './table.class';

export class Sorter<D extends object> extends AbstractSorter<D> {
   private sorter = new Srt<D>();

   constructor(ctx: LocalTable<D>, defaultSort: DefaultSort) {
      super(ctx, defaultSort)
   }
   

   public sortByCol(col: Col<D>) {
      col.sortable.state = this.sorter.getNextSortState(col.sortable.state);
      this.lastChain = this.getSortScheme(col, col.sortable.state);
      this.sortByLast();
   }


   public sortByDefault() {
      this.lastChain = this.defaultChain;
      this.defaultChain.leader.state = this.defaultChain.toState;
      this.sortByLast();
   }


   public sortByLast() {
      const rows = this.input.getValue();
      const sorted = this.sorter.sort(rows, this.lastChain);

      this.output.next(sorted);
      this.clearOtherStates();
   }


   public setNextSortScheme(col: Col<D>) {
      this.lastChain = this.getSortScheme(col, col.sortable.state);
   }
  
}

